import React from "react";
import jazzcashimg from "../../Assets/imgs/landingJazzcash/jazzcash_logo.webp";
import "../../styles/landingjazzcash.css";

type LandingJazzCashProps = {
  msisdn: string;
  errorMessage: string;
  artworkUrl: string;
  pricePoint: string;
  subscribeDisabled: boolean;
  isLoadingArtwork: boolean;
  isPrivacyPolicyChecked: boolean;
  isLoading: boolean;
  onContinueClick: () => void;
  onPrivacyPolicyClick: () => void;
  onMsisdnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};
const LandingJazzCash = (props: LandingJazzCashProps) => {
  return (
    <>
      <style>{`
        @keyframes jc-spin { to { transform: rotate(360deg); } }
        .jc-btn-spinner {
          width: 18px; height: 18px;
          border: 2px solid rgba(255,255,255,0.35);
          border-top-color: #fff;
          border-radius: 50%;
          animation: jc-spin 0.7s linear infinite;
          display: inline-block;
        }
      `}</style>
      <div className="JC--landing--page">
        <div className="JC--main--content">
          {props.isLoadingArtwork ? (
            <div className="lp-image-skeleton" />
          ) : (
            <img
              src={props.artworkUrl}
              alt="sports"
              width={345}
              height={333}
              className="lp-main-image"
            />
          )}

          <div className="lp-absolute-content">
            <div className="numberdiv">
              <p className="landingtext">Please enter your jazzcash number</p>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <div className="jc--input-wraper">
                  <span>
                    <img
                      src={jazzcashimg}
                      width={60}
                      height={28}
                      alt="jazzcash"
                    />
                  </span>

                  <input
                    value={props.msisdn}
                    inputMode="numeric"
                    type="text"
                    placeholder="3XX - XXXXXXX"
                    className="numberinput"
                    maxLength={10}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        props.onContinueClick();
                      }
                    }}
                    onChange={props.onMsisdnChange}
                  />
                </div>

                {/* <p className="error">{props.errorMessage}</p> */}
                <div
                  className={`landingJC--default--btn ${
                    props.subscribeDisabled || props.isLoading ? "disabled" : "active"
                  }`}
                  onClick={props.isLoading ? undefined : props.onContinueClick}
                >
                  {props.isLoading ? <span className="jc-btn-spinner" /> : "Subscribe"}
                </div>

                {props.errorMessage && (
                  <p className="error">{props.errorMessage}</p>
                )}
              </form>
            </div>

            <div className="otpDiv">
              <div className="policytext">
                {props.pricePoint && <p>Price Point : {props.pricePoint}</p>}
                <div className="checkflex">
                  <input
                    type="checkbox"
                    checked={props.isPrivacyPolicyChecked}
                    onClick={props.onPrivacyPolicyClick}
                  />
                  <p>
                    By signing in, you agree to the{" "}
                    <a href="/terms" target="_blank">
                      Terms of Use
                    </a>{" "}
                    and <br />
                    <a href="/privacy-policy" target="_blank">
                      Privacy Policy.
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingJazzCash;
